export enum DisputeType {
    Payment = 1,
    Invoice = 2,
}

export const DisputeTypeText: Record<DisputeType, string> = {
    [DisputeType.Payment]: "Payment",
    [DisputeType.Invoice]: "Invoice",
};